import { DatasetSessionCompare } from '../DatasetSessionCompare';

const PublicDatasetSessionCompare = () => {
  return <DatasetSessionCompare />;
};

export default PublicDatasetSessionCompare;
